export const MuiDialogStyles = {
  MuiDialog: {
    styleOverrides: {
      //It's a MuiPaper-root
      paper: {
        padding: '1.5vh',
        borderRadius: '10px',
        width: '100%',
      },
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        marginBottom: '1.5vh',
        padding: '0',
      },
    },
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        margin: '0',
      },
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        marginBottom: '1.5vh',
        padding: 0,
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: 0,
      },
    },
  },
};
